<template>
  <v-container :class="`grid-list-${$vuetify.breakpoint.name}`">
    <v-layout row wrap>
      <v-flex class="xs12 pa-0">
        <h2 class="nx-block-headline">{{ $t('message.milenium.selectContent') }}</h2>
      </v-flex>
      <v-flex class="xs12 sm4 mt-3 pr-4 hidden-xs-only">
        <nx-milenium-page-image-preview :page="page"></nx-milenium-page-image-preview>
      </v-flex>
      <v-flex class="xs12 sm8">
        <v-progress-linear v-if="loading" indeterminate color="accent" height="4"></v-progress-linear>
        <template v-else>
          <v-list v-if="positions.length > 0">
            <v-list-tile
              ripple
              v-for="(position, index) in positions"
              :key="index"
              @click="selectPosition(position)"
            >
              <v-list-tile-avatar>
                <v-icon>text_snippet</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{ position.articleName }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ position.articleId }} - {{ position.contentName }}</v-list-tile-sub-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-icon>send</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <h2 v-else class="title pa-5">{{ $t('message.milenium.pageEmpty') }}</h2>
          </template>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { delay } from '@/utils';
import api from '@/modules/milenium/api';
import NxMileniumPageImagePreview from '@/modules/milenium/components/wizard/MileniumPageImagePreview';

export default {
  components: {
    NxMileniumPageImagePreview,
  },
  props: {
    planilloId: {
      type: Number,
      required: true,
    },
    page: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      retryOnError: true,
      positions: [],
    };
  },
  computed: {
    pageId() {
      return this.page.id || null;
    },
    signature() {
      return `${this.planilloId}-${this.pageId}`;
    },
  },
  methods: {
    selectPosition(position) {
      this.$emit('input', position);
    },
    async fetchPositions() {
      if (!this.planilloId || !this.pageId) {
        this.positions = [];
        return;
      }
      this.loading = true;
      try {
        this.positions = await api.getPagePositions(this.planilloId, this.pageId);
      } catch (error) {
        if (!this.retryOnError) return;
        console.error('Error loading page positions', error);
        console.error('Retrying in 2 seconds...');
        await delay(2000);
        await this.fetchPositions();
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    signature: {
      async handler() {
        await this.fetchPositions();
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.retryOnError = false;
  },
};
</script>

<style lang="stylus" scoped>
.milenium-page {
  &-image {
    width: 100%
    max-height: 50vh
    object-fit: contain
  }

  &-footer {
    text-transform: uppercase
  }
}
</style>
